// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"355":"4bcbb1eba870520b4623","494":"b7ede4c049b2bc15456f"}[chunkId] + ".js";
};